<template>
  <v-layout row justify-center>
    <v-dialog
      v-model="isOpen"
      persistent
      scrollable
      :max-width="isFullScreen ? '' : '450'"
      :fullscreen="isFullScreen"
      >
      <v-card class="auth">
        <v-toolbar flat light>
          <v-toolbar-title :class="isFullScreen && 'subheading'">
            Add this provider to your list
          </v-toolbar-title>
          <v-spacer />
          <v-btn icon @click.stop="isOpen = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text class="auth__content">
          <iframe
            class="auth__frame"
            src="/user"
            v-if="isOpen"
            :style="{ minHeight : height + 'px' }"
          />
          <div class="auth__loading" v-if="loading">
            <v-progress-circular indeterminate color="primary"></v-progress-circular>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
  import { mapGetters, mapState } from 'vuex'

  export default {
    data () {
      return {
        loading: true,
        height: 340
      }
    },
    computed: {
      isFullScreen () {
        return this.$vuetify.breakpoint.xsOnly
      },
      ...mapGetters('user', ['isLoggedIn']),
      ...mapState('user', ['userData', 'pendingLogin', 'error']),
      isOpen: {
        get () {
          return this.pendingLogin
        },
        set () {
          if (this.pendingLogin) {
            this.loading = true
            this.$store.dispatch('user/cancelLogin')
          }
        }
      }
    },
    methods: {
      handleMessage (e) {
        let message = e.data || (e.originalEvent && e.originalEvent.data) || {}
        // If there is no status, don't try to handle it
        // It is most likely Fullstory (DOHA-1404)
        if (!message.status || !this.isOpen) {
          return
        }

        switch (message.status) {
          case 'ready':
            this.loading = false
            break

          case 'authenticated':
            this.$store.dispatch('user/login', message.data)
            window.removeEventListener('message', this.handleMessage)
            break

          case 'resize':
            this.height = message.data.height
            break

          case 'unload':
            this.loading = true
            break

          default:
            this.isOpen = false
            break
        }
      }
    },
    mounted () {
      // Only set event message event listener if unauthenticated
      if (!this.isLoggedIn) {
        window.addEventListener('message', this.handleMessage, false)
      }
    }
  }
</script>

<style lang="stylus">
  .auth
    &__content
      position: relative
      -webkit-overflow-scrolling: touch // Needed to scroll iFrame on iOS
      // (also note that autoprefix is not supported for non-standard proprties like this one)

    &__frame
      min-height: 340px
      width: 100%
      border: 0 none

    &__loading
      position: absolute
      left: 0
      top: 0
      width: 100%
      height: 100%
      display: flex
      align-items: center
      justify-content: center
      background-color: rgba(255,255,255,.9)
</style>



// WEBPACK FOOTER //
// frontend/src/components/core/AppAuthDialog.vue